import type { NewsArticle } from "@/types";

export const newsList: NewsArticle[] = [
  {
    id: "n-2001",
    title: "《长夜星河》大结局口碑逆袭，古装权谋剧的春天回来了？",
    summary:
      "开播初期争议不断，收官之战却以9.2的评分完成口碑反超。这部古装权谋剧究竟做对了什么，让观众从吐槽追到上头？",
    date: "2024-10-09",
    cover:
      "https://readdy.ai/api/search-image?query=ancient%20chinese%20palace%20at%20night%20with%20golden%20lanterns%2C%20deep%20blue%20sky%20full%20of%20stars%2C%20silhouette%20of%20royal%20guards%2C%20cinematic%20epic%20ancient%20drama%20scene%2C%20moody%20atmospheric%20lighting%2C%20high%20detail&width=1200&height=675&seq=aa-news-cover-2001&orientation=landscape",
    author: "影评组·林深",
    tags: ["剧集", "口碑", "古装"],
    content: [
      "《长夜星河》在昨晚正式收官，最终豆瓣评分定格在9.2分，成为本季度口碑最高的古装剧集。而在开播之初，这部剧曾因节奏偏慢、人物众多而受到不少质疑。",
      "从第8集开始，剧情的多线叙事逐渐收拢，前期埋下的伏笔一一回响，观众的评价也随之发生逆转。有网友留言：'前六集我差点弃剧，后面每集都在掐着点等更新。'",
      "制片方在接受采访时表示，整部剧在剧本阶段就确定了'先抑后扬'的叙事结构，希望观众能跟着主角一起，在漫长的夜里看见星光。",
      "业内人士认为，这部剧的口碑逆袭说明观众对扎实的故事与细腻的人物依旧有强烈需求。当流量红利消退，能够留住的，终究是内容本身。",
      "目前该剧已开启第二轮备案，衍生篇的相关信息或将在年底公布。",
    ],
    relatedIds: ["n-2003", "n-2006", "n-2002"],
  },
  {
    id: "n-2002",
    title: "国庆档票房破纪录，国产科幻《深海回响》凭什么领跑？",
    summary:
      "今年国庆档总票房创下同期新高，其中科幻灾难片《深海回响》以强劲走势稳居榜首。深海题材为何突然成为爆款密码？",
    date: "2024-10-08",
    cover:
      "https://readdy.ai/api/search-image?query=deep%20sea%20submarine%20exploring%20luminous%20trench%2C%20glowing%20blue%20bioluminescent%20creatures%2C%20cinematic%20sci-fi%20underwater%20scene%2C%20deep%20teal%20and%20amber%20light%20accents%2C%20dramatic%20scale%2C%20high%20detail&width=1200&height=675&seq=aa-news-cover-2002&orientation=landscape",
    author: "票房观察·陈默",
    tags: ["电影", "票房", "科幻"],
    content: [
      "根据票务平台数据，今年国庆档总票房突破42亿元，创下同期历史新高。其中《深海回响》以近14亿元的成绩稳居档期冠军。",
      "业内分析认为，这部影片的成功离不开两个关键词：技术突破与情感内核。影片大量采用实拍与虚拟拍摄结合的技术，呈现了此前国产片少有涉足的万米深海场景。",
      "更难得的是，它并没有停留在视觉奇观上。主角团队在绝境中的选择与牺牲，让不少观众在片尾曲响起时热泪盈眶。",
      "'我们想讲的不是深海有多可怕，而是人在面对未知时有多勇敢。'导演郑海生在路演中如是说。",
      "随着口碑持续发酵，该片密钥已宣布延期，业内预测其最终票房有望冲击20亿关口。",
    ],
    relatedIds: ["n-2004", "n-2007", "n-2001"],
  },
  {
    id: "n-2003",
    title: "悬疑剧《迷雾追凶》口碑封神，国产推理剧的工业化样本",
    summary:
      "没有流量明星，没有大场面，却拿下了9.0高分。《迷雾追凶》用严谨的逻辑和克制的表达，为国产悬疑剧提供了一个新标杆。",
    date: "2024-10-05",
    cover:
      "https://readdy.ai/api/search-image?query=foggy%20city%20alley%20at%20night%20with%20single%20street%20lamp%2C%20detective%20silhouette%20walking%20away%2C%20cold%20steel%20blue%20palette%2C%20tense%20mysterious%20cinematic%20mood%2C%20rain%20reflections%2C%20high%20contrast&width=1200&height=675&seq=aa-news-cover-2003&orientation=landscape",
    author: "剧评人·苏遥",
    tags: ["剧集", "悬疑", "推理"],
    content: [
      "《迷雾追凶》开播以来口碑一路走高，目前稳居平台口碑榜第一。它的特别之处在于，把'认真讲好一个案子'当作最高优先级。",
      "全剧36集，没有一个无关的支线，每一条线索都在为最终真相服务。编剧团队透露，故事大纲经历了整整两年打磨，光是凶案逻辑就推翻了七版。",
      "在制作层面，剧组采用电影级的灯光与调色标准，大量夜戏营造出压抑而真实的氛围，让观众仿佛置身案发现场。",
      "越来越多观众开始主动参与'云破案'，在社交平台上梳理线索、讨论动机，形成了一种独特的观剧文化。",
      "有制片人评价：'它证明国产剧完全可以用工业化的标准，做出既有逻辑又有质感的高水准作品。'",
    ],
    relatedIds: ["n-2001", "n-2005", "n-2008"],
  },
  {
    id: "n-2004",
    title: "治愈系爱情片《时光信箱》温暖上映，写给十年前的一封信",
    summary:
      "如果能把信寄回十年前，你想对那时的自己说什么？《时光信箱》用一个温柔的设定，叩问了每个人关于遗憾与和解的心事。",
    date: "2024-09-01",
    cover:
      "https://readdy.ai/api/search-image?query=vintage%20mailbox%20in%20golden%20hour%20garden%2C%20floating%20paper%20letters%20in%20warm%20sunlight%2C%20soft%20cream%20and%20amber%20tones%2C%20dreamy%20nostalgic%20romantic%20mood%2C%20delicate%20bokeh%2C%20high%20detail&width=1200&height=675&seq=aa-news-cover-2004&orientation=landscape",
    author: "影像志·叶轻舟",
    tags: ["电影", "爱情", "治愈"],
    content: [
      "《时光信箱》讲述了一个关于'后悔'的故事。女主在老宅阁楼发现一只旧信箱，凡是投进去的信，都会被寄往十年前。",
      "导演苏晴表示，创作灵感来自自己搬家时翻出的一盒旧信。'那些没寄出去的信，其实是我们一直没能和解的过去。'",
      "影片没有激烈的冲突，而是用大量的生活细节铺陈情绪。阳光、蝉鸣、旧自行车，构成了一个让人想一直待下去的夏天。",
      "有观众说：'散场后我坐在影院里很久没走，突然很想给高中的自己写封信。'",
      "该片目前口碑稳中有升，被视为本季最具治愈力量的爱情电影。",
    ],
    relatedIds: ["n-2002", "n-2006", "n-2003"],
  },
  {
    id: "n-2005",
    title: "《逆光而行》重映加场，运动题材为何总能击中人心？",
    summary:
      "一部上映近一年的励志电影，因为观众呼声太高而宣布重映加场。运动题材的魅力，或许就藏在那种永不放弃的呼吸感里。",
    date: "2024-09-18",
    cover:
      "https://readdy.ai/api/search-image?query=runner%20sprinting%20out%20of%20dark%20tunnel%20into%20blazing%20backlight%2C%20warm%20orange%20sun%20flare%2C%20dynamic%20motion%20blur%2C%20gritty%20realistic%20texture%2C%20inspirational%20uplifting%20cinematic%20mood%2C%20high%20detail&width=1200&height=675&seq=aa-news-cover-2005&orientation=landscape",
    author: "影评组·林深",
    tags: ["电影", "励志", "运动"],
    content: [
      "《逆光而行》官方宣布，应观众强烈要求，影片将在全国范围重映加场，并同步释出幕后纪录片。",
      "影片讲述了短跑天才在遭遇意外后，用七年时间重新站上起跑线的故事。主角佩戴义肢奔跑的结尾镜头，成为许多观众心中的年度名场面。",
      "运动题材之所以动人，往往不在于输赢，而在于那种'明知很难却依然向前'的生命状态。它让观众在黑暗中重新握紧拳头。",
      "有观众在社交平台写道：'看完之后我去跑了我今年的第一个五公里，很慢，但我没有停。'",
      "这或许就是电影最朴素的魔法——它不一定能改变命运，但能让人多坚持一个夜晚。",
    ],
    relatedIds: ["n-2004", "n-2002", "n-2008"],
  },
  {
    id: "n-2006",
    title: "年代剧《春风十里报》入选年度佳作，烟火气才是最强共鸣",
    summary:
      "没有狗血，没有反转，只有一条老街和三代人的日常。《春风十里报》用最朴素的方式，拿到了年度剧集的高口碑入场券。",
    date: "2024-01-18",
    cover:
      "https://readdy.ai/api/search-image?query=nostalgic%201990s%20old%20town%20street%20with%20spring%20blossom%20trees%2C%20family%20walking%20and%20cycling%2C%20warm%20cream%20and%20amber%20tones%2C%20gentle%20sunlight%2C%20cozy%20storytelling%20mood%2C%20high%20detail&width=1200&height=675&seq=aa-news-cover-2006&orientation=landscape",
    author: "剧评人·苏遥",
    tags: ["剧集", "年代", "家庭"],
    content: [
      "《春风十里报》凭借自然细腻的叙事，入选多个榜单的年度剧集。它讲述的，是一条老街上小满一家三代人的悲欢离合。",
      "导演顾长宁坚持使用大量实景拍摄与自然光，让画面呈现出一种久违的生活质感。'我不想拍一个被美化的过去，我想拍一个真实的过去。'",
      "剧中那些饭桌上的争吵、巷口的守望、雨夜里的等待，勾起了无数观众的集体记忆。",
      "有评论认为，年代剧的真正魅力不在于怀旧，而在于让人重新想起那些被日常磨钝的情感。",
      "该剧的续篇目前已在筹备当中。",
    ],
    relatedIds: ["n-2001", "n-2004", "n-2005"],
  },
  {
    id: "n-2007",
    title: "综艺《星球探索者》第三季官宣，极地拍摄刷新行业标准",
    summary:
      "作为国内少有的极地实景综艺，《星球探索者》第三季宣布开录。节目组透露，本季将首次挑战南极圈边缘拍摄。",
    date: "2024-09-20",
    cover:
      "https://readdy.ai/api/search-image?query=adventure%20reality%20show%20team%20on%20snowy%20mountain%20peak%20at%20sunrise%2C%20vibrant%20blue%20sky%20and%20warm%20golden%20sunlight%2C%20dramatic%20wide%20landscape%2C%20energetic%20documentary%20style%2C%20high%20detail&width=1200&height=675&seq=aa-news-cover-2007&orientation=landscape",
    author: "综艺观察·白露",
    tags: ["综艺", "真人秀", "户外"],
    content: [
      "《星球探索者》第三季正式官宣开录，本季将前往南极圈边缘进行实景拍摄，这也是国内户外综艺首次挑战该纬度。",
      "节目总导演袁野表示，新一季将减少人为设置的关卡，把更多空间交给自然本身。'真正的挑战不需要剧本，大自然已经足够严酷。'",
      "为了保障安全，节目组组建了包括极地向导、随队医生在内的专业团队，并对全部设备进行了低温环境适配。",
      "前两季积累的口碑，让这一季未播先热。不少观众表示，看这档节目最大的收获不是刺激，而是对自然的敬畏。",
      "节目预计将于明年第一季度与观众见面。",
    ],
    relatedIds: ["n-2002", "n-2008", "n-2005"],
  },
  {
    id: "n-2008",
    title: "2024年度影视盘点：哪些作品真正留在了观众心里？",
    summary:
      "又到一年盘点时。当热度散去、话题冷却，那些真正被反复提起的作品，往往才是一个行业最真实的答卷。",
    date: "2024-10-12",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20collage%20of%20movie%20and%20tv%20scenes%20on%20dark%20blue%20background%2C%20warm%20orange%20spotlight%20accents%2C%20film%20reel%20and%20clapperboard%20elements%2C%20elegant%20editorial%20year-end%20review%20mood%2C%20high%20detail&width=1200&height=675&seq=aa-news-cover-2008&orientation=landscape",
    author: "编辑部·综合",
    tags: ["盘点", "年度", "行业"],
    content: [
      "2024年即将进入尾声，这一年的影视市场既热闹又冷静。爆款依旧存在，但观众的耐心与标准也在同步提高。",
      "从剧集来看，古装权谋、悬疑推理与年代生活成为三条主线，口碑普遍向'故事扎实、人物可信'的作品倾斜。",
      "电影方面，科幻与犯罪题材表现亮眼，国产工业水准的进步有目共睹，而能真正打动人心的，依然是那些有温度的表达。",
      "综艺领域则呈现'内容为王'的回归趋势，旅行、竞技与音乐类节目通过更强的真实感赢得观众。",
      "我们梳理了过去一年中最值得回味的作品，也期待新的一年里，能有更多好故事被认真讲述。",
    ],
    relatedIds: ["n-2001", "n-2002", "n-2003"],
  },
];